import { Row, Col } from 'react-bootstrap';
import ContactCard from '../components/ContactCard';
import CustomForm from '../components/CustomForm';

function Inquiry({ contactCardType }) {
    return (
        <Row as="section" className="home-section inquiry">
            <Row className="overlay d-flex px-sm-3 px-md-4 px-lg-4 px-xl-5 px-xxl-5 py-5" xs={1} sm={1} md={1} lg={1} xl={2} xxl={2}>
                <Col className="contact-col">
                    <Col as="header" className="mb-4">
                        <h2 className='py-3'><b>GOT AN</b> INQUIRY</h2>
                        <p>Have an inquiry or want to learn more about us? Reach out using the form below or contact us directly through any of the channels listed.</p>
                    </Col>
                    <ContactCard type={ contactCardType } />
                </Col>

                {/* Inquiry Form */}
                <Col className="my-3 inquiry-col">
                    <CustomForm type="basic-inquiry" />
                </Col>
            </Row>
        </Row>
    )
}

export default Inquiry;
